
import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { Toggle } from './Toggle';
import { SmartInput } from './SmartInput';
import { ControlGroup } from './ControlGroup';

interface TrailSettingsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const TrailSettingsSection: React.FC<TrailSettingsSectionProps> = ({ config, setConfig }) => (
  <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-purple-500/5 border-purple-500/10 mb-4">
    <SectionLabel icon="fa-wave-square" darkMode={config.darkMode}>Trail Dynamics</SectionLabel>
    
    <div className="flex items-center justify-between border border-purple-500/10 p-2 rounded-xl bg-purple-500/5 mb-2">
        <div className="flex flex-col">
            <span className="text-[10px] font-black uppercase text-purple-500">Infinite Persistence</span>
            <span className="text-[8px] opacity-60">Trails never vanish</span>
        </div>
        <Toggle active={config.trailPersistence} onClick={() => setConfig(p => ({...p, trailPersistence: !p.trailPersistence}))} color="bg-purple-600" />
    </div>

    {/* NEW: BORDER CONTROLS */}
    <div className="p-2 rounded-xl border border-black/5 bg-black/5 flex flex-col gap-2">
        <span className="text-[9px] font-black uppercase opacity-60">Trail Outer Border</span>
        <div className="grid grid-cols-2 gap-3">
            <SmartInput label="Width" min={0} max={10} value={config.trailStrokeWidth} onChange={v => setConfig(p => ({...p, trailStrokeWidth: v}))} darkMode={config.darkMode} />
            <ControlGroup label="Border Color">
              <input 
                type="color" 
                value={config.trailStrokeColor} 
                onChange={e => setConfig(p => ({...p, trailStrokeColor: e.target.value}))} 
                className="w-full h-8 rounded-lg cursor-pointer bg-transparent" 
              />
            </ControlGroup>
        </div>
    </div>

    <div className="grid grid-cols-2 gap-3 mb-2 mt-2">
      <div className="flex items-center justify-between border border-purple-500/10 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">Rainbow Fill</span>
        <Toggle active={config.trailRGB} onClick={() => setConfig(p => ({...p, trailRGB: !p.trailRGB}))} color="bg-purple-600" />
      </div>
      <ControlGroup label="Custom Fill">
        <input 
          type="color" 
          value={config.trailCustomColor} 
          onChange={e => setConfig(p => ({...p, trailCustomColor: e.target.value}))} 
          disabled={config.trailRGB}
          className="w-full h-8 rounded-lg cursor-pointer bg-transparent disabled:opacity-30" 
        />
      </ControlGroup>
    </div>

    <div className="grid grid-cols-2 gap-3">
        <SmartInput label="Length" min={0} max={200} value={config.trailLength} onChange={v => setConfig(p => ({...p, trailLength: v}))} darkMode={config.darkMode} />
        <SmartInput label="Opacity" min={0} max={1} step={0.01} value={config.trailOpacity} onChange={v => setConfig(p => ({...p, trailOpacity: v}))} darkMode={config.darkMode} />
    </div>

    <div className="grid grid-cols-2 gap-3">
        <SmartInput label="Thickness" min={0.1} max={10} step={0.1} value={config.trailWidthMultiplier} onChange={v => setConfig(p => ({...p, trailWidthMultiplier: v}))} darkMode={config.darkMode} />
        <SmartInput label="Glow" min={0} max={50} value={config.trailGlowAmount} onChange={v => setConfig(p => ({...p, trailGlowAmount: v}))} darkMode={config.darkMode} />
    </div>

    <div className="grid grid-cols-2 gap-3">
        <SmartInput label="Start Scale" min={0.1} max={3} step={0.1} value={config.trailStartScale} onChange={v => setConfig(p => ({...p, trailStartScale: v}))} darkMode={config.darkMode} />
        <SmartInput label="End Scale" min={0.1} max={3} step={0.1} value={config.trailEndScale} onChange={v => setConfig(p => ({...p, trailEndScale: v}))} darkMode={config.darkMode} />
    </div>

    <SmartInput label="Spawn Interval" min={1} max={500} value={config.trailInterval} onChange={v => setConfig(p => ({...p, trailInterval: v}))} darkMode={config.darkMode} />
  </div>
);
